import { api, makeApiRequest } from './_init'

export const fetchLoginImages = async (signal) => {
  const res = await makeApiRequest(api, 'get', '/login-images', null, { signal })

  if (res?.data?.images?.length) {
    return { success: true, data: res.data.images }
  }
  
  return { success: false, error: res?.error || 'No images returned' }
}
